import React from 'react';
import { useParams } from 'react-router-dom';
import { useArticlesGetById } from '../../../../hooks/api/articles';
import ViewContent from './Content';

export default function ArticlesView(): React.ReactNode | null {
  const { id } = useParams();
  const articlesGetById = useArticlesGetById(id);
  const { data, loading } = articlesGetById;

  return <ViewContent data={data} loading={loading} id={id} />;
}
